import { OcaTemplate, ReferenceType } from '@trnsact/trnsact-shared-types';

export const getSectionByReferenceType = (ocaTemplate: OcaTemplate, referenceType: ReferenceType) => {
  return ocaTemplate?.jsonDefinition
    .flatMap((page: any) => page.sections)
    .find((section: any) => section.referenceType === referenceType);
};

export const getSectionByFieldName = (ocaTemplate: OcaTemplate, fieldName: string) => {
  return ocaTemplate?.jsonDefinition
    .flatMap((page: any) => page.sections)
    .find((section: any) => section.fields?.find((field: any) => field.config.fieldName === fieldName));
};
